//
// locales/vanilla/th.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/th.json';
import localeData from 'react-intl/locale-data/th.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
